export interface INavigationRoute {
  name: string
  displayName: string
  permission_name: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      permission_name: 'Dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },
    {
      name: 'staffs',
      displayName: 'menu.staffs',
      permission_name: 'User Management',
      meta: {
        icon: 'group',
      },
    },
    {
      name: 'customers-list',
      displayName: 'menu.customers',
      permission_name: 'Customer Management',
      meta: {
        icon: 'group',
      },
    },
    // {
    //   name: 'roles',
    //   displayName: 'menu.roles',
    //   permission_name: 'Dashboard',
    //   meta: {
    //     icon: 'group',
    //   },
    // },
    {
      name: 'terminals-list',
      displayName: 'menu.terminals',
      permission_name: 'Terminal Management',
      meta: {
        icon: 'folder_shared',
      },
    },
    {
      name: 'transactions-list',
      displayName: 'menu.transactions',
      permission_name: 'Transactions',
      meta: {
        icon: 'folder_shared',
      },
    },
    {
      name: 'pricings',
      displayName: 'menu.pricings',
      permission_name: 'Pricing',
      meta: {
        icon: 'settings',
      },
    },
    {
      name: 'provider-balances',
      displayName: 'menu.provider-balances',
      permission_name: 'Pricing',
      meta: {
        icon: 'settings',
      },
    },
    {
      name: 'profile-settings',
      displayName: 'menu.settings',
      permission_name: 'Dashboard',
      meta: {
        icon: 'settings',
      },
    },
  ] as INavigationRoute[],
}
